import { ButtonHTMLAttributes } from "react";

type OptionsProps = {
  name: string;
  checked: boolean;
  value: string;
  onChange: (e: any) => void;
  className?: string;
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, "onChange">;

export function Option(props: OptionsProps) {
  return (
    <button
      className={`rounded-md border  px-3 py-2 text-bold1 text-xs ${
        props.checked
          ? "border-brand-color bg-gray-100"
          : "border-gray-300 bg-white text-gray-500"
      } ${props?.className}`}
      onClick={props.onChange}
      value={props.value}
    >
      {" "}
      {props.name}{" "}
    </button>
  );
}
